/** @format */

export const SimCardEntity = {
    clientId: null,
    msisdn: null,
    iccid: null,
    imsi: null,
    autoRecharge: false,
    tariffId: null,
    active: true,
    autoactivationdate: null,
    externalAccountId: null,
    temporaryCallerId: null,
    servicesTemplateId: null,
    isVirtual: false,
    mvnoAutoActivate: true,
    isPrepaid: false,
    reloadServicesTepmplate: false,
    removePeriod: null,
    deleteReason: null,
    serviceOrderId: null,
    tariffPlanId: null,
    ipPrivate: null,
    ipPublic: null,
    isPorted: false,
};

export const SimCardStatus = {
    clientId: null,
    msisdn: null,
    iccid: null,
    imsi: null,
    autoRecharge: null,
    tariffId: null,
    active: null,
    autoactivationdate: null,
    externalAccountId: null,
    temporaryCallerId: null,
    servicesTemplateId: null,
    isVirtual: null,
    mvnoAutoActivate: null,
    isPrepaid: null,
    reloadServicesTepmplate: null,
    removePeriod: null,
    deleteReason: null,
    serviceOrderId: null,
    tariffPlanId: null,
    ipPrivate: null,
    ipPublic: null,
    isPorted: null,
};
